import React from 'react';
import TextField from '@mui/material/TextField';

const InputComponent = ({ inputRef, ...other }) => <div {...other} />;
const OutlinedDiv = ({ children, label, style, color }) => {
  return (
    <TextField
      variant="outlined"
      label={label}
      style={style}
      multiline
      InputLabelProps={{ shrink: true }}
      InputProps={{
        inputComponent: InputComponent,
      }}
      inputProps={{ children }}
    />
  );
};
export default OutlinedDiv;
